import { render, staticRenderFns } from "./ModalSobreposicaoTerritorioParaguai.vue?vue&type=template&id=46c6bf6a&lang=pug"
import script from "./ModalSobreposicaoTerritorioParaguai.vue?vue&type=script&lang=js"
export * from "./ModalSobreposicaoTerritorioParaguai.vue?vue&type=script&lang=js"
import style0 from "./ModalSobreposicaoTerritorioParaguai.vue?vue&type=style&index=0&id=46c6bf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports